import { useEffect, useState } from 'react';
import { useMap } from '@vis.gl/react-google-maps';

export default function EraserTool({ active, onBoundsChanged }) {
  const map = useMap();
  const [rectangle, setRectangle] = useState(null);

  useEffect(() => {
    if (!map || !window.google) return;

    if (active) {
      if (!rectangle) {
        const center = map.getCenter();
        // Create a small rectangle at the center of the map
        const bounds = {
          north: center.lat() + 0.02,
          south: center.lat() - 0.02,
          east: center.lng() + 0.02,
          west: center.lng() - 0.02,
        };

        const rect = new window.google.maps.Rectangle({
          bounds,
          editable: true,
          draggable: true,
          map: map,
          fillColor: '#3b82f6', // Bright Blue
          fillOpacity: 0.25,
          strokeColor: '#2563eb', // Darker Blue
          strokeWeight: 3,
          zIndex: 9999
        });

        rect.addListener('bounds_changed', () => {
          if (onBoundsChanged) onBoundsChanged(rect.getBounds());
        });

        // initial bounds
        if (onBoundsChanged) onBoundsChanged(rect.getBounds());

        setRectangle(rect);
      }
    } else {
      if (rectangle) {
        rectangle.setMap(null);
        setRectangle(null);
      }
    }
  }, [map, active, rectangle, onBoundsChanged]);

  return null;
}
